import { AHInput, AHTextFonts, useLayoutContext, useTheme } from "arkh";
import React from "react";
import { useIntl } from "react-intl";

export function KPISubTeamNameInput(props: {
  name: string;
  setName(_: string): void;
}) {
  const theme = useTheme();
  const layout = useLayoutContext();
  const intl = useIntl();
  return (
    <AHInput
      value={props.name}
      placeholder={intl.formatMessage({
        defaultMessage: "Measurement area name",
        description: "KPISubTeamNameInput placeholder",
      })}
      autoCapitalize="sentences"
      autoFocus
      onChangeText={props.setName}
      style={{
        flex: 1,
        fontFamily: AHTextFonts.REGULAR,
        fontSize: 16,
        backgroundColor: theme.surface,
        borderRadius: layout.radius.large,
        paddingVertical: layout.space.medium,
        paddingHorizontal: layout.space.medium,
      }}
    />
  );
}
